import { StyleSheet } from 'react-native';
import type { WcColors } from './matchPickStats.helper';

export function getPickStatsOutcomePieStyles(C: WcColors) {
  return StyleSheet.create({
    pieInner: {
      padding: 14,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 16,
    },
    pieChartWrap: {
      width: 140,
      height: 140,
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    },
    pieCenterLabel: {
      position: 'absolute',
      alignItems: 'center',
      justifyContent: 'center',
    },
    pieCenterLabelPointerEvents: {
      pointerEvents: 'none' as never,
    },
    pieCenterPct: {
      fontSize: 18,
      fontWeight: '900',
    },
    pieCenterKey: {
      fontSize: 10,
      color: C.inkDim,
      fontWeight: '700',
      marginTop: 1,
      textAlign: 'center',
    },
    pieLegend: {
      flex: 1,
      gap: 10,
    },
    pieLegendRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    pieLegendDot: {
      width: 10,
      height: 10,
      borderRadius: 5,
    },
    pieLegendLabel: {
      fontSize: 13,
      color: C.inkDim,
    },
    pieLegendPct: {
      fontSize: 13,
      fontWeight: '800',
      marginLeft: 'auto' as never,
    },
    totalPicksText: {
      fontSize: 11,
      color: C.inkMute,
      marginBottom: 10,
    },
  });
}
